import { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { unitMapping } from '@sorare/core/src/lib/style';

const Root = styled(Horizontal).attrs({ center: true })`
  background: var(--footer-bg-color);
  transition: background-color 0.3s ease-in-out;
  color: var(--c-nd-700);
  padding: 0 var(--half-unit);

  &:last-child {
    overflow: hidden;
    border-bottom-left-radius: var(--unit);
    border-bottom-right-radius: var(--unit);
  }
`;

type Props = { children: ReactNode; height?: keyof typeof unitMapping };

export const BasicBenchExtraWrapper = ({ children, height = 2.5 }: Props) => {
  return (
    <Root center style={{ height: unitMapping[height] }}>
      {children}
    </Root>
  );
};
